export const RepairOrderReopenLabel = "Repair Order Reopen";
export const NewLabel = "New";